import React from "react";
import t from "../helpers/t";

type Tag = {
  counter?: number;
  label: string;
};
type Props = {
  tags: Tag[];
  tagSet: boolean;
  onFilterRemoveHandle: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onTagClicked: (name: string) => void;
  updateTagList: (e: React.MouseEvent<HTMLDivElement>) => void;
};
const TagList = ({ tags, tagSet, onFilterRemoveHandle, onTagClicked, updateTagList }: Props) => {
  return (
    <>
      <ul
        id="inb-c-left-bar-flist--tag"
        className="inb-vert-list"
        data-inb-filter="tag"
        data-inb-action-link="filter_by_tag"
      >
        <span className="inb-list-title">TAGS</span>
        {tagSet && (
          <a
            href="#"
            className="unset-filter"
            onClick={(e) => {
              onFilterRemoveHandle(e);
            }}
            title={t("unselect_filter")}
          >
            x
          </a>
        )}
        <ul className="tag-cloud-box">
          {tags.map((tag, index) => {
            return (
              <>
                <li
                  className=""
                  data-counter={tag.counter}
                  data-inb-val={tag.label}
                  title={t("filter_tag_${a}", { a: tag.label })}
                  key={"tag_" + index + "_" + tag.label}
                >
                  <a
                    href="#"
                    className="order-sidebar-tag-link"
                    onClick={() => {
                      onTagClicked(tag.label);
                    }}
                  >
                    {tag.label}
                  </a>
                </li>
              </>
            );
          })}
        </ul>
        <div id="order-sidebar-tags-update-btn" className="hide" onClick={updateTagList}></div>
      </ul>
    </>
  );
};

export default TagList;
